function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { nanoid } from 'nanoid';
import memoize from 'memoize-one';
import { FadeTransition } from '@deephaven/components';
import { LayoutUtils, PanelEvent } from '@deephaven/dashboard';
import { DateTimeColumnFormatter, DateUtils, TableUtils } from '@deephaven/jsapi-utils';
import Log from '@deephaven/log';
import { Type as FilterType } from '@deephaven/filters';
import { getActiveTool, getApi, getTimeZone, setActiveTool as setActiveToolAction } from '@deephaven/redux';
import { assertNotNull } from '@deephaven/utils';
import { getIsolatedLinkerPanelIdForDashboard, getLinksForDashboard, setDashboardLinks as setDashboardLinksAction, addDashboardLinks as addDashboardLinksAction, deleteDashboardLinks as deleteDashboardLinksAction, setDashboardIsolatedLinkerPanelId as setDashboardIsolatedLinkerPanelIdAction, setDashboardColumnSelectionValidator as setDashboardColumnSelectionValidatorAction } from "../redux/index.js";
import ToolType from "./ToolType.js";
import { ChartEvent, IrisGridEvent } from "../events/index.js";
import LinkerOverlayContent from "./LinkerOverlayContent.js";
import LinkerUtils, { isLinkablePanel, isLinkableColumn } from "./LinkerUtils.js";
import { listenForFilterColumnsChanged } from "../FilterEvents.js";
import { listenForLinkPointSelected, listenForLinkSourceDataSelected, listenForRegisterLinkTarget } from "./LinkerEvent.js";
import { jsx as _jsx } from "react/jsx-runtime";
var log = Log.module('Linker');
var mapState = (state, ownProps) => ({
  activeTool: getActiveTool(state),
  dh: getApi(state),
  isolatedLinkerPanelId: getIsolatedLinkerPanelIdForDashboard(state, ownProps.localDashboardId),
  links: getLinksForDashboard(state, ownProps.localDashboardId),
  timeZone: getTimeZone(state)
});
var connector = connect(mapState, {
  setActiveTool: setActiveToolAction,
  setDashboardLinks: setDashboardLinksAction,
  addDashboardLinks: addDashboardLinksAction,
  deleteDashboardLinks: deleteDashboardLinksAction,
  setDashboardIsolatedLinkerPanelId: setDashboardIsolatedLinkerPanelIdAction,
  setDashboardColumnSelectionValidator: setDashboardColumnSelectionValidatorAction
});
export class Linker extends Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "linkTargetPropMap", new Map());
    _defineProperty(this, "removerFns", []);
    _defineProperty(this, "getCachedLinks", memoize((links, linkInProgress, isolateForPanelId) => {
      var combinedLinks = [...links];
      if (linkInProgress != null && linkInProgress.start != null) {
        combinedLinks.push(linkInProgress);
      }
      if (isolateForPanelId !== undefined) {
        return combinedLinks.filter(link => {
          var _link$start, _link$end;
          return (link === null || link === void 0 || (_link$start = link.start) === null || _link$start === void 0 ? void 0 : _link$start.panelId) === isolateForPanelId || (link === null || link === void 0 || (_link$end = link.end) === null || _link$end === void 0 ? void 0 : _link$end.panelId) === isolateForPanelId || (link === null || link === void 0 ? void 0 : link.end) == null;
        });
      }
      // Show all links in regular linker mode -- both isolated and not
      return combinedLinks;
    }));
    this.handleCancel = this.handleCancel.bind(this);
    this.handleDone = this.handleDone.bind(this);
    this.handlePanelCloned = this.handlePanelCloned.bind(this);
    this.handleColumnsChanged = this.handleColumnsChanged.bind(this);
    this.handlePanelClosed = this.handlePanelClosed.bind(this);
    this.handleLayoutStateChanged = this.handleLayoutStateChanged.bind(this);
    this.handleAllLinksDeleted = this.handleAllLinksDeleted.bind(this);
    this.handleLinkDeleted = this.handleLinkDeleted.bind(this);
    this.handleLinksUpdated = this.handleLinksUpdated.bind(this);
    this.handleChartColumnSelect = this.handleChartColumnSelect.bind(this);
    this.handleGridColumnSelect = this.handleGridColumnSelect.bind(this);
    this.handleUpdateValues = this.handleUpdateValues.bind(this);
    this.handleStateChange = this.handleStateChange.bind(this);
    this.handleExited = this.handleExited.bind(this);
    this.handleLinkPointSelected = this.handleLinkPointSelected.bind(this);
    this.handleTargetRegistered = this.handleTargetRegistered.bind(this);
    this.handleLinkSelected = this.handleLinkSelected.bind(this);
    this.handlePanelDragging = this.handlePanelDragging.bind(this);
    this.handlePanelDropped = this.handlePanelDropped.bind(this);
    this.isColumnSelectionValid = this.isColumnSelectionValid.bind(this);
    this.state = {
      linkInProgress: undefined,
      selectedIds: new Set(),
      isDraggingPanel: false
    };
  }
  componentDidMount() {
    var layout = this.props.layout;
    this.startListening(layout);
    this.updateSelectionValidators();
  }
  componentDidUpdate(prevProps) {
    var _this$props = this.props,
      activeTool = _this$props.activeTool,
      layout = _this$props.layout;
    if (layout !== prevProps.layout) {
      this.stopListening(prevProps.layout);
      this.startListening(layout);
    }
    if (activeTool !== prevProps.activeTool) {
      this.updateSelectionValidators();
      if (activeTool === ToolType.DEFAULT) {
        this.reset();
      }
    }
  }
  componentDidCatch(error, info) {
    log.error('componentDidCatch', error, info);
  }
  componentWillUnmount() {
    var layout = this.props.layout;
    this.stopListening(layout);
  }
  startListening(layout) {
    layout.on('stateChanged', this.handleLayoutStateChanged);
    var eventHub = layout.eventHub;
    eventHub.on(IrisGridEvent.COLUMN_SELECTED, this.handleGridColumnSelect);
    eventHub.on(IrisGridEvent.DATA_SELECTED, this.handleUpdateValues);
    eventHub.on(IrisGridEvent.STATE_CHANGED, this.handleStateChange);
    eventHub.on(ChartEvent.COLUMN_SELECTED, this.handleChartColumnSelect);
    eventHub.on(PanelEvent.CLONED, this.handlePanelCloned);
    this.removerFns = [listenForFilterColumnsChanged(eventHub, this.handleColumnsChanged), listenForLinkPointSelected(eventHub, this.handleLinkPointSelected), listenForLinkSourceDataSelected(eventHub, this.handleUpdateValues), listenForRegisterLinkTarget(eventHub, this.handleTargetRegistered)];
    eventHub.on(PanelEvent.CLOSE, this.handlePanelClosed);
    eventHub.on(PanelEvent.CLOSED, this.handlePanelClosed);
    eventHub.on(PanelEvent.DRAGGING, this.handlePanelDragging);
    eventHub.on(PanelEvent.DROPPED, this.handlePanelDropped);
  }
  stopListening(layout) {
    layout.off('stateChanged', this.handleLayoutStateChanged);
    var eventHub = layout.eventHub;
    eventHub.off(IrisGridEvent.COLUMN_SELECTED, this.handleGridColumnSelect);
    eventHub.off(IrisGridEvent.DATA_SELECTED, this.handleUpdateValues);
    eventHub.off(IrisGridEvent.STATE_CHANGED, this.handleStateChange);
    eventHub.off(ChartEvent.COLUMN_SELECTED, this.handleChartColumnSelect);
    eventHub.off(PanelEvent.CLONED, this.handlePanelCloned);
    eventHub.off(PanelEvent.CLOSE, this.handlePanelClosed);
    eventHub.off(PanelEvent.CLOSED, this.handlePanelClosed);
    eventHub.off(PanelEvent.DRAGGING, this.handlePanelDragging);
    eventHub.off(PanelEvent.DROPPED, this.handlePanelDropped);
    this.removerFns.forEach(remove => remove());
    this.removerFns = [];
  }
  reset() {
    this.setState({
      linkInProgress: undefined,
      selectedIds: new Set()
    });
  }
  handleCancel() {
    var linkInProgress = this.state.linkInProgress;
    if (linkInProgress == null) {
      var setActiveTool = this.props.setActiveTool;
      setActiveTool(ToolType.DEFAULT);
    }
    this.setState({
      linkInProgress: undefined
    });
  }
  handleDone() {
    var setActiveTool = this.props.setActiveTool;
    setActiveTool(ToolType.DEFAULT);
  }
  handleChartColumnSelect(panel, column) {
    var panelId = LayoutUtils.getIdFromPanel(panel);
    assertNotNull(panelId);
    this.columnSelected(panelId, column, 'chartLink', true);
  }
  handleColumnsChanged(sourceId, columns) {
    log.debug('handleColumnsChanged', sourceId, columns);
    var links = this.props.links;
    if (sourceId == null) {
      log.error('Invalid filter columns source id', sourceId);
      return;
    }

    // Columns is null when dh.ui widgets with linker capability are closed
    if (columns == null) {
      this.deleteLinksForPanelId(sourceId);
      return;
    }
    // NOTE: links need to be updated to use sourceId instead of panelId. This will be done when we implement linker for dh.ui widgets DH-18840
    // Delete links that start or end on non-existent column in the updated panel
    var linksToDelete = links.filter(_ref => {
      var start = _ref.start,
        end = _ref.end;
      return start.panelId === sourceId && LinkerUtils.findColumn(columns, start) == null || end != null && end.panelId === sourceId && LinkerUtils.findColumn(columns, end) == null;
    });
    this.deleteLinks(linksToDelete);
  }
  handleGridColumnSelect(panel, column) {
    if (!isLinkableColumn(column)) {
      log.debug2('Column is not filterable');
      return;
    }
    var panelId = LayoutUtils.getIdFromPanel(panel);
    assertNotNull(panelId);
    this.columnSelected(panelId, column, 'tableLink');
  }
  handleLinkPointSelected(sourceId, column, options) {
    var type = options.type;
    var isIsolatedLinker = type === 'filterSource';
    var isAlwaysEnd = type === 'chartLink' || type === 'filterSource';

    // filterSource type should open in isolated linker mode
    if (!this.isOverlayShown() && sourceId != null && isIsolatedLinker) {
      var _this$props2 = this.props,
        links = _this$props2.links,
        localDashboardId = _this$props2.localDashboardId,
        setActiveTool = _this$props2.setActiveTool,
        setDashboardIsolatedLinkerPanelId = _this$props2.setDashboardIsolatedLinkerPanelId;
      var panelLinks = links.filter(link => {
        var _link$start2, _link$end2;
        return ((_link$start2 = link.start) === null || _link$start2 === void 0 ? void 0 : _link$start2.panelId) === sourceId || ((_link$end2 = link.end) === null || _link$end2 === void 0 ? void 0 : _link$end2.panelId) === sourceId;
      });

      // Initial click on the filter source button with linker inactive
      // Show linker in isolated mode for panel
      setActiveTool(ToolType.LINKER);
      setDashboardIsolatedLinkerPanelId(localDashboardId, sourceId);
      if (panelLinks.length === 0) {
        // Source not linked - start new link in isolated linker mode
        // Need to pass panelId for overrideIsolatedLinkerPanelId
        // as redux prop update at this point not yet propagated
        this.columnSelected(sourceId, column, type, isAlwaysEnd, sourceId);
      }
      return;
    }
    this.columnSelected(sourceId, column, type, isAlwaysEnd);
  }

  /**
   * Track a column selection and build the link from it.
   * @param sourceId The ID of the source for the column selection
   * @param column The column that was selected
   * @param type The type of the link point
   * @param isAlwaysEndPoint True if the selection is always the end point, even if it's the first column selected. Defaults to false.
   * @param overrideIsolatedLinkerPanelId isolatedLinkerPanelId to use when method is called before prop changes propagate
   */
  columnSelected(sourceId, column, type) {
    var isAlwaysEndPoint = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var overrideIsolatedLinkerPanelId = arguments.length > 4 ? arguments[4] : undefined;
    if (overrideIsolatedLinkerPanelId === undefined && !this.isOverlayShown()) {
      return;
    }
    var isolatedLinkerPanelId = this.props.isolatedLinkerPanelId;
    var linkInProgress = this.state.linkInProgress;
    var columnName = column.name,
      columnType = column.type;
    if (linkInProgress == null || linkInProgress.start == null) {
      var newLink = {
        id: nanoid(),
        start: {
          panelId: sourceId,
          columnName,
          columnType
        },
        type: 'invalid',
        isReversed: isAlwaysEndPoint
      };
      if (isAlwaysEndPoint) {
        newLink.endType = type;
      }
      log.debug('starting link', newLink);
      this.setState({
        linkInProgress: newLink
      });
    } else {
      var _linkInProgress$endTy;
      var links = this.props.links;
      var start = linkInProgress.start,
        id = linkInProgress.id,
        _linkInProgress$isRev = linkInProgress.isReversed,
        isReversed = _linkInProgress$isRev === void 0 ? false : _linkInProgress$isRev;
      var end = {
        panelId: sourceId,
        columnName,
        columnType
      };
      var isValid = !(isReversed && isAlwaysEndPoint) &&
      // Cannot add a point which is only an end when we already have an end
      LinkerUtils.isLinkValid(isReversed ? end : start, isReversed ? start : end, overrideIsolatedLinkerPanelId !== null && overrideIsolatedLinkerPanelId !== void 0 ? overrideIsolatedLinkerPanelId : isolatedLinkerPanelId);
      if (!isValid) {
        log.debug('Ignore invalid link connection', linkInProgress, end);
        return;
      }

      // The end point is what determines the type
      // If the link is reversed, we already set the type on the linkInProgress
      var finalType = (_linkInProgress$endTy = linkInProgress.endType) !== null && _linkInProgress$endTy !== void 0 ? _linkInProgress$endTy : type;
      switch (finalType) {
        case 'invalid':
          log.debug('Ignore invalid link connection', linkInProgress, end);
          return;
        case 'filterSource':
          {
            // filterSource links have a limit of 1 link per target
            // New link validation passed, delete existing links before adding the new one
            var existingLinkPanelId = isReversed !== undefined && isReversed ? start.panelId : end.panelId;
            // In cases with multiple targets per panel (i.e. chart filters)
            // links would have to be filtered by panelId and columnName and columnType
            var linksToDelete = links.filter(_ref2 => {
              var panelLinkEnd = _ref2.end;
              return (panelLinkEnd === null || panelLinkEnd === void 0 ? void 0 : panelLinkEnd.panelId) === existingLinkPanelId;
            });
            this.deleteLinks(linksToDelete);
            break;
          }
        case 'chartLink':
          {
            var existingLinkEnd = isReversed === true ? start : end;
            var existingLinkStart = isReversed === true ? end : start;
            log.debug('creating chartlink', {
              existingLinkEnd,
              start,
              end
            });
            // Don't allow linking more than one column per source to each chart column
            var _linksToDelete = links.filter(_ref3 => {
              var panelLinkEnd = _ref3.end,
                panelLinkStart = _ref3.start;
              return (panelLinkStart === null || panelLinkStart === void 0 ? void 0 : panelLinkStart.panelId) === existingLinkStart.panelId && (panelLinkEnd === null || panelLinkEnd === void 0 ? void 0 : panelLinkEnd.panelId) === existingLinkEnd.panelId && (panelLinkEnd === null || panelLinkEnd === void 0 ? void 0 : panelLinkEnd.columnName) === existingLinkEnd.columnName && (panelLinkEnd === null || panelLinkEnd === void 0 ? void 0 : panelLinkEnd.columnType) === existingLinkEnd.columnType;
            });
            this.deleteLinks(_linksToDelete);
            break;
          }
        case 'tableLink':
          // No-op
          break;
      }

      // Create a completed link from link in progress
      var _newLink = {
        start: isReversed ? end : start,
        end: isReversed ? start : end,
        id,
        type: finalType,
        operator: FilterType.eq
      };
      log.info('creating link', _newLink);
      this.setState({
        linkInProgress: undefined,
        selectedIds: new Set([id])
      }, () => {
        // Adding link after updating state
        // otherwise both new link and linkInProgress could be rendered at the same time
        // resulting in "multiple children with same key" error
        this.addLinks([_newLink]);
      });
    }
  }
  unsetFilterValueForLink(link) {
    var panelManager = this.props.panelManager;
    if (link.end) {
      var _linkTargetPropMap$ge;
      var end = link.end;
      var panelId = end.panelId,
        columnName = end.columnName,
        columnType = end.columnType;
      var linkTargetPropMap = this.linkTargetPropMap;
      var unsetFilterValue = (_linkTargetPropMap$ge = linkTargetPropMap.get(panelId)) === null || _linkTargetPropMap$ge === void 0 ? void 0 : _linkTargetPropMap$ge.unsetFilterValue;
      if (unsetFilterValue) {
        unsetFilterValue(columnName, columnType);
        return;
      }
      var endPanel = panelManager.getOpenedPanelById(panelId);
      if (!endPanel) {
        log.debug('endPanel no longer exists or target is not a panel. Ignoring unsetFilterValue', panelId);
      } else if (isLinkablePanel(endPanel)) {
        endPanel.unsetFilterValue(columnName, columnType);
      } else {
        log.debug('endPanel.unsetFilterValue not implemented', endPanel);
      }
    }
  }

  /**
   * Set filters for a given panel ID
   * @param panelId ID of panel to set filters on
   * @param filterMap Map of column name to column type, text, and value
   */
  setPanelFilterMap(panelId, filterMap) {
    var _linkTargetPropMap$ge2;
    log.debug('Set filter data for panel:', panelId, filterMap);
    var panelManager = this.props.panelManager;
    var linkTargetPropMap = this.linkTargetPropMap;
    var setFilterValues = (_linkTargetPropMap$ge2 = linkTargetPropMap.get(panelId)) === null || _linkTargetPropMap$ge2 === void 0 ? void 0 : _linkTargetPropMap$ge2.setFilterValues;
    if (setFilterValues) {
      setFilterValues(filterMap);
      return;
    }
    var panel = panelManager.getOpenedPanelById(panelId);
    if (!panel) {
      log.debug('panel no longer exists or target is not a panel. Ignoring setFilterMap', panelId);
    } else if (isLinkablePanel(panel)) {
      panel.setFilterMap(filterMap);
    } else {
      log.debug('panel.setFilterMap not implemented', panelId, panel);
    }
  }
  addLinks(links) {
    var _this$props3 = this.props,
      addDashboardLinks = _this$props3.addDashboardLinks,
      localDashboardId = _this$props3.localDashboardId;
    addDashboardLinks(localDashboardId, links);
  }
  deleteLinks(links) {
    var clearAll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var localDashboardId = this.props.localDashboardId;
    links.forEach(link => this.unsetFilterValueForLink(link));
    if (clearAll) {
      var setDashboardLinks = this.props.setDashboardLinks;
      setDashboardLinks(localDashboardId, []);
    } else if (links.length > 0) {
      var deleteDashboardLinks = this.props.deleteDashboardLinks;
      deleteDashboardLinks(localDashboardId, links.map(_ref4 => {
        var id = _ref4.id;
        return id;
      }));
    }
  }
  handleAllLinksDeleted() {
    var _this$props4 = this.props,
      links = _this$props4.links,
      isolatedLinkerPanelId = _this$props4.isolatedLinkerPanelId;
    if (isolatedLinkerPanelId === undefined) {
      this.deleteLinks(links, true);
    } else {
      var isolatedLinks = links.filter(link => {
        var _link$start3, _link$end3;
        return (link === null || link === void 0 || (_link$start3 = link.start) === null || _link$start3 === void 0 ? void 0 : _link$start3.panelId) === isolatedLinkerPanelId || (link === null || link === void 0 || (_link$end3 = link.end) === null || _link$end3 === void 0 ? void 0 : _link$end3.panelId) === isolatedLinkerPanelId;
      });
      this.deleteLinks(isolatedLinks);
    }
    this.reset();
  }
  handleLinkDeleted(linkId) {
    var links = this.props.links;
    var link = links.find(l => l.id === linkId);
    if (link) {
      this.deleteLinks([link]);
    } else {
      log.error('Unable to find link to delete', linkId);
    }
  }
  handleTargetRegistered(sourceId, handlers) {
    var linkTargetPropMap = this.linkTargetPropMap;
    if (handlers == null) {
      linkTargetPropMap.delete(sourceId);
    } else {
      linkTargetPropMap.set(sourceId, handlers);
    }
  }
  handleUpdateValues(sourceId, dataMap) {
    var _this$props5 = this.props,
      dh = _this$props5.dh,
      links = _this$props5.links,
      timeZone = _this$props5.timeZone;
    // Map of panel ID to filterMap
    var panelFilterMap = new Map();
    // Instead of setting filters one by one for each link,
    // combine them so they could be set in a single call per target panel
    for (var i = 0; i < links.length; i += 1) {
      var _links$i = links[i],
        start = _links$i.start,
        end = _links$i.end,
        operator = _links$i.operator;
      if (start.panelId === sourceId && end != null) {
        var _filterMap$get$filter, _filterMap$get;
        var endPanelId = end.panelId,
          columnName = end.columnName,
          columnType = end.columnType;
        // Map of column name to column type and filter value
        var existingFilterMap = panelFilterMap.get(endPanelId);
        var filterMap = existingFilterMap !== null && existingFilterMap !== void 0 ? existingFilterMap : new Map();
        var filterList = (_filterMap$get$filter = (_filterMap$get = filterMap.get(columnName)) === null || _filterMap$get === void 0 ? void 0 : _filterMap$get.filterList) !== null && _filterMap$get$filter !== void 0 ? _filterMap$get$filter : [];
        var _dataMap$start$column = dataMap[start.columnName],
          startColumnIndex = _dataMap$start$column.visibleIndex,
          isExpandable = _dataMap$start$column.isExpandable,
          isGrouped = _dataMap$start$column.isGrouped;
        var value = dataMap[start.columnName].value;
        var text = "".concat(value);
        if (value === null && isExpandable && isGrouped) {
          // Clear filter on empty rollup grouping columns
          value = undefined;
        }
        if (columnType != null && TableUtils.isDateType(columnType)) {
          var dateFilterFormatter = new DateTimeColumnFormatter(dh, {
            timeZone,
            showTimeZone: false,
            showTSeparator: true,
            defaultDateTimeFormatString: DateUtils.FULL_DATE_FORMAT
          });
          // The values are Dates for dateType values, not string like everything else
          text = dateFilterFormatter.format(value);
        }
        filterList.push({
          operator,
          text,
          value,
          startColumnIndex
        });
        filterMap.set(columnName, {
          columnType,
          filterList
        });
        panelFilterMap.set(endPanelId, filterMap);
      }
    }

    // Apply combined filters to all target panels
    panelFilterMap.forEach((filterMap, endPanelId) => {
      this.setPanelFilterMap(endPanelId, filterMap);
    });
  }
  handlePanelCloned(panel, cloneConfig) {
    var links = this.props.links;
    var panelId = LayoutUtils.getIdFromPanel(panel);
    var cloneId = cloneConfig.id;
    if (panelId != null) {
      var linksToAdd = LinkerUtils.cloneLinksForPanel(links, panelId, cloneId);
      this.addLinks(linksToAdd);
    }
  }
  handlePanelDragging(componentId) {
    var links = this.props.links;
    for (var i = 0; i < links.length; i += 1) {
      var link = links[i];
      var start = link.start,
        end = link.end;
      if (start.panelId === componentId || (end === null || end === void 0 ? void 0 : end.panelId) === componentId) {
        this.setState({
          isDraggingPanel: true
        });
        return;
      }
    }
  }
  handlePanelDropped() {
    this.setState({
      isDraggingPanel: false
    });
  }
  handlePanelClosed(panelId) {
    // Delete links on PanelEvent.CLOSE and PanelEvent.CLOSED instead of UNMOUNT
    // because the panels can get unmounted on errors and we want to keep the links if that happens
    log.debug("Panel ".concat(panelId, " closed, deleting links."));
    this.deleteLinksForPanelId(panelId);
  }
  handleLinkSelected(linkId) {
    this.setState({
      selectedIds: new Set([linkId])
    });
  }
  handleLinksUpdated(newLinks) {
    var _this$props6 = this.props,
      localDashboardId = _this$props6.localDashboardId,
      setDashboardLinks = _this$props6.setDashboardLinks;
    setDashboardLinks(localDashboardId, newLinks);
  }
  handleLayoutStateChanged() {
    this.forceUpdate();
  }
  handleStateChange() {
    this.forceUpdate();
  }
  handleExited() {
    // Has to be done after linker exit animation to avoid flashing non-isolated links
    var _this$props7 = this.props,
      localDashboardId = _this$props7.localDashboardId,
      setDashboardIsolatedLinkerPanelId = _this$props7.setDashboardIsolatedLinkerPanelId;
    setDashboardIsolatedLinkerPanelId(localDashboardId, undefined);
  }

  /**
   * Delete all links for a provided panel ID. Needs to be done whenever a panel is closed or unmounted.
   * @param panelId The panel ID to delete links for
   */
  deleteLinksForPanelId(panelId) {
    var links = this.props.links;
    for (var i = 0; i < links.length; i += 1) {
      var link = links[i];
      var start = link.start,
        end = link.end,
        id = link.id;
      if (start.panelId === panelId || (end === null || end === void 0 ? void 0 : end.panelId) === panelId) {
        this.handleLinkDeleted(id);
      }
    }
  }
  isOverlayShown() {
    var activeTool = this.props.activeTool;
    return activeTool === ToolType.LINKER;
  }
  updateSelectionValidators() {
    var _this$props8 = this.props,
      activeTool = _this$props8.activeTool,
      setDashboardColumnSelectionValidator = _this$props8.setDashboardColumnSelectionValidator,
      localDashboardId = _this$props8.localDashboardId;
    switch (activeTool) {
      case ToolType.LINKER:
        setDashboardColumnSelectionValidator(localDashboardId, this.isColumnSelectionValid);
        break;
      default:
        setDashboardColumnSelectionValidator(localDashboardId, undefined);
        break;
    }
  }
  updateLinkInProgressType() {
    var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'invalid';
    this.setState(_ref5 => {
      var linkInProgress = _ref5.linkInProgress;
      if (linkInProgress !== undefined) {
        return {
          linkInProgress: _objectSpread(_objectSpread({}, linkInProgress), {}, {
            type
          })
        };
      }
      return null;
    });
  }
  isColumnSelectionValid(panelOrId, tableColumn, options) {
    var _linkInProgress$endTy2;
    var linkInProgress = this.state.linkInProgress;
    var isolatedLinkerPanelId = this.props.isolatedLinkerPanelId;
    // This is backwards compatibility for Grizzly Enterprise panels
    // IrisGridPanel is the only allowed start point for a link
    // The enterprise panels will not call this method with options
    // They are also JS and removed in sanluis, so figure this is best for now
    var isAlwaysEnd = typeof panelOrId === 'string' ? options.type === 'filterSource' || options.type === 'chartLink' : LayoutUtils.getComponentNameFromPanel(panelOrId) !== 'IrisGridPanel';
    if (tableColumn == null) {
      if ((linkInProgress === null || linkInProgress === void 0 ? void 0 : linkInProgress.start) != null) {
        // Link started, end point is not a valid target
        this.updateLinkInProgressType('invalid');
      }
      return false;
    }

    // TODO: Use preview/original type property when core/#3358 is completed
    if (!isLinkableColumn(tableColumn)) {
      log.debug2('Column is not filterable', tableColumn.description);
      if ((linkInProgress === null || linkInProgress === void 0 ? void 0 : linkInProgress.start) != null) {
        this.updateLinkInProgressType('invalid');
      }
      return false;
    }

    // Link not started yet - no need to update type
    if ((linkInProgress === null || linkInProgress === void 0 ? void 0 : linkInProgress.start) == null) {
      return true;
    }
    var _linkInProgress$isRev2 = linkInProgress.isReversed,
      isReversed = _linkInProgress$isRev2 === void 0 ? false : _linkInProgress$isRev2,
      start = linkInProgress.start;
    var panelId = typeof panelOrId === 'string' ? panelOrId : LayoutUtils.getIdFromPanel(panelOrId);
    if (panelId == null) {
      return false;
    }

    // We've already selected an end point, so we can't select another one
    if (isReversed && isAlwaysEnd) {
      this.updateLinkInProgressType('invalid');
      return false;
    }
    var end = {
      panelId,
      columnName: tableColumn.name,
      columnType: tableColumn.type
    };
    var isValid = isReversed ? LinkerUtils.isLinkValid(end, start, isolatedLinkerPanelId) : LinkerUtils.isLinkValid(start, end, isolatedLinkerPanelId);
    this.updateLinkInProgressType(isValid ? (_linkInProgress$endTy2 = linkInProgress.endType) !== null && _linkInProgress$endTy2 !== void 0 ? _linkInProgress$endTy2 : options.type : 'invalid');
    return isValid;
  }
  render() {
    var _this$props9 = this.props,
      links = _this$props9.links,
      isolatedLinkerPanelId = _this$props9.isolatedLinkerPanelId,
      panelManager = _this$props9.panelManager;
    var _this$state = this.state,
      linkInProgress = _this$state.linkInProgress,
      selectedIds = _this$state.selectedIds,
      isDraggingPanel = _this$state.isDraggingPanel;
    var isLinkOverlayShown = this.isOverlayShown();
    var disabled = linkInProgress != null && linkInProgress.start != null;
    var linkerOverlayMessage = isolatedLinkerPanelId === undefined ? 'Click a column source, then click a column target to create a filter link. The filter comparison operator used by a selected link can be changed. Delete a filter link by clicking the delete button or with alt+click. Click done when finished.' : 'Create a link between the source column button and a table column by clicking on one, then the other. Delete a filter link by clicking the delete button or with alt+click. Click done when finished.';
    return !isDraggingPanel ? /*#__PURE__*/_jsx(FadeTransition, {
      in: isLinkOverlayShown,
      mountOnEnter: true,
      unmountOnExit: true,
      onExited: this.handleExited,
      children: /*#__PURE__*/_jsx(LinkerOverlayContent, {
        disabled: disabled,
        panelManager: panelManager,
        links: this.getCachedLinks(links, linkInProgress, isolatedLinkerPanelId),
        selectedIds: selectedIds,
        messageText: linkerOverlayMessage,
        onLinkSelected: this.handleLinkSelected,
        onLinkDeleted: this.handleLinkDeleted,
        onAllLinksDeleted: this.handleAllLinksDeleted,
        onLinksUpdated: this.handleLinksUpdated,
        onDone: this.handleDone,
        onCancel: this.handleCancel,
        linkTargetPropMap: this.linkTargetPropMap
      })
    }) : null;
  }
}
var ConnectedLinker = connector(Linker);
export default ConnectedLinker;
//# sourceMappingURL=Linker.js.map